export class Tenant {
    tenantName!: string;
    companyName!: string;
    apiUrl!: string;
    cdnUrl!: string;
    companyLogoUrl!: string;
    logoUrl!: string;
    clientId!: string;
}